export default __webpack_public_path__ + "static/media/icon-bar.19529ce8.svg";